/**
 * the conceptual types of values data input menu can return
 * (e.g. item data [single value], table column or table item [array value])
 */
export const DATA_INPUT_MENU_ALLOWED_VALUES = Object.freeze({
	TABLE: Symbol(1),
	TABLE_COLUMN: Symbol(2),
	ITEM_DATA: Symbol(3),
});

export const ITEM_ONLY_ALLOWED_VALUE_TYPES = [DATA_INPUT_MENU_ALLOWED_VALUES.ITEM_DATA];
export const TABLE_ONLY_ALLOWED_VALUE_TYPES = [DATA_INPUT_MENU_ALLOWED_VALUES.TABLE];
export const TABLE_AND_ITEM_ALLOWED_VALUE_TYPES = [DATA_INPUT_MENU_ALLOWED_VALUES.TABLE, DATA_INPUT_MENU_ALLOWED_VALUES.ITEM_DATA];

// Data input menu tab codes
export const EXTERNAL_SOURCE_TAB_KEY = 'field_params';
export const THIS_FLOW_TAB_KEY = 'this_flow';
export const SELECT_TAB_KEY = 'select_params';
export const PREVIOUS_STEP_TABLE_OUTPUT = 'table_output';

// Data input menu listeners
export const SET_VALUE_FROM_PREVIOUS_STEP = 'update-previous-step-localValue';
export const SET_TEXT_VALUE = 'update-text-localValue';
export const REFRESH_DATA = 'refresh-data';
export const SET_VALUE_FROM_EXTERNAL_SOURCE = 'update-external-localValue';
export const CLOSE_MENU = 'close-menu';
export const SET_VALUE_FROM_TABLE_SOURCE = 'set-value-from-table-source';
export const UPDATE_SEARCH_STRING = 'update-search-string';
export const RE_CLAC_MENU_POSITION = 're-calc-menu-position';

export const getDataInputMenuTab = (key, title, isConst, custom) => ({ tab: key, title, isConst, custom });

export const DATA_INPUT_MENU_MIN_WIDTH = 370;
export const DATA_INPUT_MENU_MAX_WIDTH = 440;
export const DATA_INPUT_MENU_MAX_HEIGHT = 320;
export const DATA_INPUT_MENU_SEARCH_FIELD_HEIGHT = 30;

export const DATA_ITEM_KEY_TO_IGNORE = '$PLY-VALUE';
